import { Component, EventEmitter, Input, Output, SimpleChanges, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SortModel } from '../../../core/api/models/sort-model';

@Component({
    selector: 'app-field-sorter',
    templateUrl: './field-sorter.component.html',
    styleUrls: ['./field-sorter.component.scss'],
    standalone: false
})
export class FieldSorterComponent {
  route = inject(ActivatedRoute);

  @Input() title: string; //column title
  @Input() name: string; //column name
  @Input() needCurrency: boolean = false;
  @Input() noSorting: boolean = false;
  @Input() clearFilters: boolean = true;

  // 0 => sort off
  // 1 => descending
  // 2 => ascending
  sort: number = 0;

  @Output() sortItem = new EventEmitter<SortModel>();

  constructor() {}

  ngOnInit(): void {
     this.setModelFromUrl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clearFilters']) {
       this.setModelFromUrl();
      this.sort = 0;
    }
  }

  setModelFromUrl() {
    if(window.location.pathname == "/phonebook" || window.location.pathname == "/smsTemplateGroup") return;
    const urlObj = new URL(window.location.href);
    const url = new URLSearchParams(urlObj.search);
    const params = {};
    for (const [key, value] of url.entries()) {
      if (key.startsWith('sort')) params[key] = value;
    }

    for (const [key, value] of Object.entries(params)) {
      let sort = key.split('_')[1];
      if (value == this.name && value != undefined) {
        this.sort = Number(sort);
      }
    }
  }

  changeSort() {
    if (this.noSorting) return;
    this.sort++;
    if (this.sort === 3) {
      this.sort = 0;
    }
    this.emit();
  }

  emit() {
    this.sortItem.emit({
      columnName: this.name,
      sort: this.sort,
    });
  }
}
